import * as React from 'react';
import { t } from '@reos/i18n';
import { ChevronLeft } from 'lucide-react';

/**
 * Krok UXV4c — navigacni lista naboru (predloha `Nabor.png`: „Zavřít" vlevo,
 * titulek uprostred, stav site vpravo). Stav site rika, ze nabor funguje i bez
 * signalu („offline OK") a kolik veci jeste ceka na odeslani.
 */
export function IntakeHeader({
  title,
  back,
  backIsChevron = false,
  online,
  pending,
}: {
  readonly title: string;
  readonly back: { readonly label: string; readonly onClick: () => void };
  readonly backIsChevron?: boolean;
  readonly online: boolean;
  readonly pending: number;
}): React.JSX.Element {
  const state = pending > 0 ? 'pending' : online ? 'online' : 'offline';
  return (
    <div className="rh-fi-nav" data-testid="fi-header">
      <button type="button" className="rh-fi-nav__back" onClick={back.onClick} data-testid="fi-back">
        {backIsChevron ? <ChevronLeft size={22} strokeWidth={2.5} aria-hidden="true" /> : null}
        {back.label}
      </button>
      <h1 className="rh-fi-nav__title">{title}</h1>
      <span className={`rh-fi-net rh-fi-net--${state}`} data-testid="fi-net" role="status">
        <span className="rh-fi-net__dot" aria-hidden="true" />
        {state === 'pending'
          ? t('webAdmin.fieldIntake.net.pending', { locale: 'cs', values: { count: pending } })
          : state === 'online'
            ? t('webAdmin.fieldIntake.net.online', { locale: 'cs' })
            : t('webAdmin.fieldIntake.net.offline', { locale: 'cs' })}
      </span>
    </div>
  );
}

/** Online stav prohlizece (udalosti `online`/`offline`). */
export function useOnline(): boolean {
  const [online, setOnline] = React.useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  React.useEffect(() => {
    const on = (): void => setOnline(true);
    const off = (): void => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
